var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoodSad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.23562 21.06L8.96253 21.4241L9.69077 21.9703L9.96386 21.6062L9.23562 21.06ZM22.0356 21.6062L22.3087 21.9703L23.037 21.4241L22.7639 21.06L22.0356 21.6062ZM15.9997 30.4779C8.00366 30.4779 1.52156 23.9958 1.52156 15.9997H0.611254C0.611254 24.4986 7.50091 31.3882 15.9997 31.3882V30.4779ZM30.4779 15.9997C30.4779 23.9958 23.9958 30.4779 15.9997 30.4779V31.3882C24.4986 31.3882 31.3882 24.4986 31.3882 15.9997H30.4779ZM15.9997 1.52156C23.9958 1.52156 30.4779 8.00366 30.4779 15.9997H31.3882C31.3882 7.50091 24.4986 0.611254 15.9997 0.611254V1.52156ZM15.9997 0.611254C7.50091 0.611254 0.611254 7.50091 0.611254 15.9997H1.52156C1.52156 8.00366 8.00366 1.52156 15.9997 1.52156V0.611254ZM8.53307 12.1882H10.6664V11.2779H8.53307V12.1882ZM21.3331 12.1882H23.4664V11.2779H21.3331V12.1882ZM22.7639 21.06C19.3818 16.5506 12.6177 16.5506 9.23562 21.06L9.96386 21.6062C12.9818 17.5822 19.0177 17.5822 22.0356 21.6062L22.7639 21.06Z",
    fill: "#13100D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodSad);
export default __webpack_public_path__ + "static/media/mood-sad.1867a1148d09f1a1266bb29d4d71d7f7.svg";
export { ForwardRef as ReactComponent };